export default function (form) {
    return (form.submission_count() || '0') + (form.max_submissions() ? '/' + form.max_submissions() : '');
}
